import { fetchBanks, selectedBanks } from '@shared-core/features/backend'
import { useNotifications } from '@shared-core/features/notifications'
import { useEvent } from '@shared-core/hooks/use-event'
import { useI18N } from '@shared-core/hooks/use-i18n'
import { useAppDispatch, useAppSelector } from '@shared-core/store'
import locales from './use-withdraw-availability.i18n.json'

export function useWithdrawAvailability() {
  const dispatch = useAppDispatch()
  const banks = useAppSelector(selectedBanks)
  const { addToast } = useNotifications()
  const { t } = useI18N(locales)

  return useEvent(async () => {
    const availableBanks = banks ?? (await dispatch(fetchBanks()).unwrap())

    if (availableBanks?.length) return true

    addToast({ text: t('withdraw-unavailable'), isClosable: false, timeout: 3500, override: true })
    return false
  })
}
